<template>
  <div class="form-container">
    <div class="form">
      <div class="form__title">
        <h1>Request Form</h1>
        <p>
          Please use the form below to request supplier or game information,
          request a new supplier or the addition of a supplier.
        </p>
      </div>
      <q-form @submit.prevent="onSubmit" class="q-gutter-md">
        <q-input
          outlined
          type="text"
          v-model="form.name"
          label="Full Name *"
          lazy-rules
          :rules="[
            (val) => !!val || '* Required',
            (val) => val.length > 1 || '* Please enter a full name',
          ]"
          ><template v-slot:prepend>
            <q-icon name="mood" />
          </template>
        </q-input>
        <q-input
          outlined
          type="email"
          v-model="form.email"
          label="Email *"
          lazy-rules
          :rules="[(val) => !!val || '* Email is missing', isValidEmail]"
          ><template v-slot:prepend>
            <q-icon
              name="mail_outline
"
            />
          </template>
        </q-input>

        <q-input
          outlined
          type="text"
          v-model="form.company"
          label="Company *"
          lazy-rules
          :rules="[
            (val) => !!val || '* Required',
            (val) => val.length > 1 || '* Please enter a company',
          ]"
          ><template v-slot:prepend>
            <q-icon
              name="business
"
            />
          </template>
        </q-input>

        <q-select
          outlined
          v-model="form.subject"
          :options="subjectOptions"
          label="Subject *"
          lazy-rules
          :rules="[(val) => !!val || '* Required']"
          ><template v-slot:prepend>
            <q-icon name="subject" />
          </template>
        </q-select>

        <q-input
          outlined
          type="textarea"
          v-model="form.message"
          label="Message *"
          lazy-rules
          :rules="[
            (val) => !!val || '* Required',
            (val) => val.length > 1 || '* Please enter your message',
          ]"
          ><template v-slot:prepend>
            <q-icon name="help_outline" />
          </template>
        </q-input>

        <div>
          <q-btn
            label="Submit"
            type="submit"
            color="secondary"
            class="full-width"
            unelevated
            no-caps
          />
          <p v-if="error">{{ error }}</p>
          <p v-if="success">{{ success }}</p>
        </div>
      </q-form>
    </div>
    <SuccessMessage :message="this.success" v-show="success" />
  </div>
</template>
<script>
import SuccessMessage from "@/components/other/SuccessMessage.vue";
export default {
  props: {
    formType: String,
  },
  data() {
    return {
      form: {
        name: null,
        email: null,
        company: null,
        subject: null,
        message: null,
      },
      subjectOptions: ["Supplier Request", "Game Request", "Other"],
      success: false,
      error: null,
    };
  },
  components: {
    SuccessMessage,
  },

  methods: {
    // Input validations
    isValidEmail(val) {
      const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      return emailPattern.test(val) || "Invalid email";
    },

    onSubmit: function(event) {
      // type is the endpoint form we want to hit, to is who we want the form to notify - these are added as props
      const payload = {
        form: {
          type: this.$props.formType,
          content: {
            Name: this.form.name,
            Email: this.form.email,
            Company: this.form.company,
            Subject: this.form.subject,
            Message: this.form.message,
            RequestedBy: this.$store.state.userDetails.email,
          },
        },
      };

      this.$store
        .dispatch("submitEmailData", payload)
        .then(() => {
          this.form.name = null;
          this.form.email = null;
          this.form.company = null;
          this.form.subject = null;
          this.form.message = null;
          this.success = "Request sent";
          event.target.reset();
          setTimeout(() => {
            this.success = "";
            this.error = "";
          }, 4000);
        })
        .catch((error) => {
          this.error = "Request could not be sent";
          this.response = "Error: " + error.response;
        });
    },
  },
};
</script>

<style lang="scss">
.form-container {
  display: flex;
  width: 100%;
  height: 100%;
}
</style>
